import { useEffect, useState } from 'react';
import { getAllInvoiceGroups } from 'src/shared/services/invoiceGroupService';
import { getIncomingBankPayments } from 'src/shared/services/incomingBankPaymanetService';
import { IncomingBankPaymentStatusEnum } from 'src/shared/models/enums/incomingBankPaymentStatus.enum';

/** Returns the total number of unmatched (faulty) incoming bank payments across all invoice groups */
export const useUnmatchedPaymentsBadge = () => {
  const [totalCount, setTotalCount] = useState(0);

  useEffect(() => {
    getAllInvoiceGroups(0, 500, 'name', 'asc', '')
      .then(async (groupsRes) => {
        const groups = groupsRes.data.results;
        if (!groups.length) return;

        const counts = await Promise.all(
          groups.map((group) =>
            getIncomingBankPayments(0, 1, 'date', 'desc', '', group.owner_id, IncomingBankPaymentStatusEnum.UnMatched)
              .then((res) => res.data.totalItems)
              .catch(() => 0),
          ),
        );

        setTotalCount(counts.reduce((sum, c) => sum + c, 0));
      })
      .catch(() => undefined);
  }, []);

  return totalCount;
};
